export const challenge = (action = 'CARD_PAYMENT') => {
  return new Promise((resolve) => {
    if (!process.env.VUE_APP_RECAPTCHA_KEY) {
      return resolve(undefined);
    }

    // eslint-disable-next-line no-undef
    grecaptcha.enterprise.ready(async () => {
      // eslint-disable-next-line no-undef
      const token = await grecaptcha.enterprise.execute(process.env.VUE_APP_RECAPTCHA_KEY, {action});
      resolve(token);
    });
  });
}
